import React from 'react';

import CreateStorageForm from 'containers/pages/servers/Storage/Create/CreateStorageForm';

const CreateCloudBlockStorage = () => {
	return <CreateStorageForm allowServerSelection isDialog />;
};

export default CreateCloudBlockStorage;
